import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c23521c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3c23521c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c23521c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c23521c')) {
      api.createRecord('3c23521c', component.options)
    } else {
      api.reload('3c23521c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3c23521c&scoped=true", function () {
      api.rerender('3c23521c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/delivery/index.vue"
export default component.exports